import {
  ComponentPropsWithoutRef,
  Dispatch,
  SetStateAction,
  useEffect,
  useState,
} from "react";
import classNames from "classnames";

type Props = ComponentPropsWithoutRef<"input"> & {
  initialInput: string;
  setInputFocusing: Dispatch<SetStateAction<boolean>>;
  save: (newValue?: string) => void;
};

export default function PartInput({
  initialInput,
  setInputFocusing,
  save,
  className,
  ...rest
}: Props) {
  const [input, setInput] = useState<string>();
  useEffect(() => setInput(undefined), [initialInput]);
  const extraClasses =
    rest.required && !(input ?? initialInput) ? "outline outline-red-500" : "";

  return (
    <input
      className={classNames("p-1 rounded-sm bg-white", className, extraClasses)}
      value={input ?? initialInput}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      onChange={(e) => setInput(e.target.value)}
      onFocus={() => setInputFocusing(true)}
      onBlur={() => {
        setInputFocusing(true);
        if (input !== undefined) {
          // if on change hasn't been called, input stays undefined
          // and we don't need to save that
          save(input);
        }
      }}
      onKeyUp={(e) => {
        if (e.key === "Enter") {
          e.currentTarget.blur();
        } else if (e.key === "Escape") {
          setInput(undefined);
        }
      }}
      {...rest}
    />
  );
}
